import type {
  AgentOutcome,
  AvailabilitySnapshot,
  BookingRecord,
  GuardReason,
} from "./types";

export function availabilityOutcome(snapshot: AvailabilitySnapshot): AgentOutcome {
  return {
    kind: "availability_presented",
    availableSlots: [...snapshot.slots],
    snapshotVersion: snapshot.version,
  };
}

export function bookedOutcome(
  booking: BookingRecord,
  replayed: boolean,
): AgentOutcome {
  return {
    kind: "appointment_booked",
    bookingId: booking.bookingId,
    slot: booking.slot,
    replayed,
  };
}

export function blockedOutcome(
  reason: GuardReason | "adapter_rejected_mutation",
): AgentOutcome {
  return {
    kind: "mutation_blocked",
    tool: "book_appointment",
    reason,
  };
}

export function failedOutcome(
  code: "planner_exhausted" | "invalid_request",
): Extract<AgentOutcome, { kind: "failed" }> {
  return {
    kind: "failed",
    code,
  };
}
